import { anyOf } from '@/router/routeMeta.js';
import { RoleGroups, Roles } from '@/router/roles';

export const supportRoutes = [
	{
		path: 'employee/support',
		name: 'Employee Support Dashboard',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/EmployeeSupportDashboard.vue')
	},
	{
		path: 'employee/support/categories',
		name: 'Support Ticket Categories',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/TicketCategoryManagement.vue')
	},
	{
		path: 'employee/support/sla',
		name: 'Support SLA Metrics',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/SupportSlaMetrics.vue')
	},
	{
		path: 'employee/support/doc-categories',
		name: 'Support Doc Categories',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/DocCategoryManagement.vue')
	},
	{
		path: 'employee/support/docs',
		name: 'Employee Support Docs',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/SupportDoc.vue')
	},
	{
		path: 'employee/support/docs/new',
		name: 'Support Docs New',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/components/SupportDocEditor.vue')
	},
	{
		path: 'employee/support/docs/edit/:id',
		name: 'Support Docs Edit',
		meta: anyOf(RoleGroups.SUPPORT_ADMIN),
		component: () => import('@/views/EvergreenSports/Support/components/SupportDocEditor.vue')
	},
	{
		path: 'support',
		name: 'Support Dashboard',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportDashboard/SupportDashboard.vue')
	},
	{
		path: 'support/tickets',
		name: 'Support Tickets',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportTicketList.vue')
	},
	{
		path: 'support/new',
		name: 'Create Support Ticket',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportTicketCreate.vue')
	},
	{
		path: 'support/:id',
		name: 'Support Ticket Detail',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportTicketDetail.vue'),
		props: true
	},
	{
		path: 'support/docs',
		name: 'Support Articles',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportArticles/SupportDocsHome.vue')
	},
	{
		path: 'support/docs/:slug',
		name: 'View Support Article',
		meta: Roles.USER,
		component: () => import('@/views/Support/SupportArticles/ViewSupportArticle.vue')
	}
];
